import PropTypes from 'prop-types';

export const treeItemShape = {
  key: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

treeItemShape.children = PropTypes.arrayOf(PropTypes.shape(treeItemShape));
